import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { CssBaseline, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { ROUTES } from "../../actions/app/constants";
import { setActiveRoute } from "../../actions/app/navigation";
import PlacementList from "../../components/PlacementList";

const useStyles = makeStyles((theme) => ({
  route: {
    position: "relative",
    minHeight: "86vh"
  }
}));

const Home = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveRoute(ROUTES.PLACEMENT_LIST));
  }, [dispatch]);

  return (
    <div className={classes.route}>
      <CssBaseline />
      <Container maxWidth="xl">
        <PlacementList />
      </Container>
    </div>
  );
};

export default Home;
